export default "__VITE_ASSET__DTFgPs4B__"